import { childAgeMonthLabel } from "../../../shared/utils/childAge";
import {
  DEPARTMENT_TYPE_OPTIONS,
  CHILD_GENDER_OPTIONS,
} from "./searchOptions";

export interface BuildDisplayQueryParams {
  doctorId: number | null;
  doctorFamilyName: string;
  doctorFirstName: string;
  hasPediatricDepartment: boolean;
  childAgeSlider: number[];
  childGenders: number[];
}

export function buildDisplayQuery(params: BuildDisplayQueryParams): string {
  const parts: string[] = [];

  if (params.doctorId == null && (params.doctorFamilyName.length > 0 || params.doctorFirstName.length > 0)) {
    parts.push("回答者:" + params.doctorFamilyName + params.doctorFirstName);
  }

  if (params.hasPediatricDepartment) {
    if (params.childAgeSlider[0] !== 0 || params.childAgeSlider[1] !== 35) {
      parts.push(childAgeMonthLabel(params.childAgeSlider[0]) + "〜" + childAgeMonthLabel(params.childAgeSlider[1], true));
    }
    params.childGenders.forEach((val) => {
      const found = CHILD_GENDER_OPTIONS.find((o) => o.value === val);
      if (found) parts.push(found.text);
    });
  }

  return parts.join(", ");
}

export function buildDisplayOption(params: { isOperatorDoctor: boolean; excludeMode: "without_exclude" | "only_exclude" | "with_exclude" }): string {
  if (!params.isOperatorDoctor) return "";

  if (params.excludeMode === "only_exclude") return "除外中の事例のみ";
  if (params.excludeMode === "with_exclude") return "全ての事例";
  return "";
}

export function formatDepartmentTypes(departmentTypes: number[]): string {
  return departmentTypes
    .map((dt) => DEPARTMENT_TYPE_OPTIONS.find((d) => d.value === dt)?.text)
    .filter(Boolean)
    .join(", ");
}
